export default __webpack_public_path__ + "static/media/ktm_logo.85f6fa98.png";